import React from 'react';
import { Input, FormGroup, FormFeedback, Label } from 'reactstrap';
import PropTypes from 'prop-types';

export default function CustomTextarea({
  onChange,
  name,
  label,
  value,
  placeholder,
  invalid,
  errorMess,
  className,
  rows,
  formClassName
}) {
  return (
    <FormGroup className={formClassName}>
      <Label>{label}</Label>
      <Input
        type='textarea'
        className={className}
        onChange={onChange}
        name={name}
        value={value}
        rows={rows}
        placeholder={placeholder}
        invalid={invalid}
      />
      <FormFeedback style={{ marginBottom: '-20px' }}>{errorMess}</FormFeedback>
    </FormGroup>
  );
}

CustomTextarea.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  rows: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  invalid: PropTypes.bool,
  errorMess: PropTypes.string,
  className: PropTypes.string
};
